import { REGISTRATION_UPLOAD_TOO_LARGE_MESSAGE } from "./file-limits";

const REGISTRATION_FAILURE_FALLBACK = "Registration failed. Please try again.";

function messageParts(message: unknown): string[] {
  if (typeof message === "string" && message.trim()) return [message.trim()];
  if (!Array.isArray(message)) return [];
  return message
    .filter((item): item is string => typeof item === "string" && item.trim().length > 0)
    .map((item) => item.trim());
}

export function formatRegistrationRequestError(error: unknown): string {
  if (error && typeof error === "object") {
    const err = error as {
      code?: string;
      response?: { status?: number; data?: unknown };
    };
    if (err.code === "ECONNABORTED") {
      return "Registration is taking too long. Try again on a stronger connection or use smaller photos.";
    }
    if (err.response?.status === 413) {
      return REGISTRATION_UPLOAD_TOO_LARGE_MESSAGE;
    }
    if (err.response?.data !== undefined) {
      return formatRegistrationFailure(err.response.data);
    }
  }
  return formatRegistrationFailure(undefined);
}

export function formatRegistrationFailure(data: unknown): string {
  if (!data || typeof data !== "object") return REGISTRATION_FAILURE_FALLBACK;

  const body = data as { message?: unknown; errors?: unknown };
  const parts = messageParts(body.message);
  if (parts.length > 0 && parts.every((part) => part.toLowerCase() === "file too large")) {
    return REGISTRATION_UPLOAD_TOO_LARGE_MESSAGE;
  }

  const summary = parts.join(". ");
  const extras: string[] = [];
  if (body.errors && typeof body.errors === "object" && !Array.isArray(body.errors)) {
    for (const value of Object.values(body.errors as Record<string, unknown>)) {
      if (typeof value !== "string") continue;
      const detail = value.trim();
      if (detail && !summary.includes(detail)) extras.push(detail);
    }
  }

  const text = [...parts, ...extras].join(". ");
  return text || REGISTRATION_FAILURE_FALLBACK;
}
